import React, { Component } from 'react';
import Page from '../../../components/Page';
import { Icon, Breadcrumb, Table, Tab, Button, Segment, Step, Message } from 'semantic-ui-react';
import { Link, Prompt } from 'react-router-dom';
import _ from 'lodash';
import useFetch from 'use-http';
import { Formik } from 'formik';
import MyMenu from '../menu';
import { BooleanInput, TableLine } from '../inputs';
import { connect } from 'react-redux';
import { FacebookProvider, Status, LoginButton } from 'react-facebook';
import 'react-intl-tel-input/dist/main.css';
import { post } from '../../../util/api';
import AccountProgress from '../../../components/AccountProgress';
import { withTranslation, useTranslation } from 'react-i18next';

const fetch_config = { responseType: 'json', cachePolicy: 'no-cache' };
const FACEBOOK_COMMENT_OPTION_KEYS = ['facebook_comments'];

function FacebookCommentOptions() {
	const { t } = useTranslation();
	const { loading, response } = useFetch('/api/dahi/message/getLiveChat', fetch_config, []);
	const result = response && response.data && response.data.result;
	const initialValues = React.useMemo(() => {
		if (!result) return { agent: {} };
		const { staticOptions, agentOptions } = result;
		const combined = _.assignIn({}, agentOptions, staticOptions);
		return { agent: _.pick(combined, FACEBOOK_COMMENT_OPTION_KEYS) };
	}, [result]);
	if (loading)
		return (
			<Tab.Pane>
				<div style={{ textAlign: 'center' }}>
					<Icon name="asterisk" loading></Icon>
					<p>{t('loading')}</p>
				</div>
			</Tab.Pane>
		);
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={(values, actions) => {
				fetch('/api/dahi/channel/save', {
					method: 'POST',
					body: JSON.stringify({
						channel: 'live',
						data: {
							set: {
								staticOptions: _.pick(values.agent, FACEBOOK_COMMENT_OPTION_KEYS),
							},
						},
					}),
					headers: {
						'Content-Type': 'application/json',
					},
				})
					.then((response) => {
						return response.json();
					})
					.then(() => {
						actions.resetForm(values);
						actions.setSubmitting(false);
					})
					.catch((e) => {
						console.error(e);
						actions.setSubmitting(false);
					});
			}}
		>
			{(props) => (
				<Tab.Pane>
					<form onSubmit={props.handleSubmit}>
						<Prompt when={props.dirty} message={() => t('questionWithoutSaving')} />
						<Table definition>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell width={2} />
									<Table.HeaderCell>{t('value')}</Table.HeaderCell>
								</Table.Row>
							</Table.Header>

							<Table.Body>
								<TableLine title={t('facebookComment')} description={t('facebookCommentDesc')}>
									<BooleanInput name="agent.facebook_comments" />
								</TableLine>
							</Table.Body>
						</Table>
						<div style={{ textAlign: 'end' }}>
							<Button loading={props.isSubmitting} primary type="submit">
								{t('saveChanges')}
							</Button>
						</div>
					</form>
				</Tab.Pane>
			)}
		</Formik>
	);
}

class PageSeceltor extends Component {
	state = { loading: true, buttonLoading: -1, list: [] };

	async componentDidMount() {
		const [connectedPages, apiresponse] = await Promise.all([
			post('/messenger/register/list').then((data) =>
				_.filter(data.data.result, function (it) {
					return it.accessToken;
				})
			),
			new Promise((cb) => window.FB.api('/me/accounts', cb)),
		]);
		if (apiresponse) this.setState({ connectedPages, loading: false, list: apiresponse.data });
		else this.setState({ connectedPages, loading: false, error: 'etc...' });
	}

	connect = (props) => async () => {
		this.setState({ buttonLoading: props.id });
		await post('/messenger/register/connect', { page_id: props.id, page_access_token: props.token }).then(async (response) => {
			// livechat konuşma listesinde Messenger filtresi için staticOptions'a yaz
			await post('/dahi/channel/save', { channel: 'live', data: { set: { staticOptions: { filter_facebook: true } } } }).catch(console.error);
			this.setState({ buttonLoading: -1 });
			window.location.reload();
		});
	};
	disconnect = (props) => async () => {
		this.setState({ buttonLoading: props.id });
		await post('/messenger/register/disconnect', { page_id: props.id, page_access_token: props.token }).then((response) => {
			this.setState({ buttonLoading: -1 });
			window.location.reload();
		});
	};
	render() {
		/* console.log('sss', this.state.connectedPages, this.state.list); */
		const { t } = this.props;
		if (this.state.loading)
			return (
				<div style={{ textAlign: 'center' }}>
					<Icon name="asterisk" loading></Icon>
					<p>{t('loading')}</p>
				</div>
			);
		return (
			<div>
				<div style={{ textAlign: 'end' }}>
					<LoginButton
						className="ui button facebook"
						scope="pages_manage_metadata,pages_messaging,business_management,pages_read_engagement,pages_manage_engagement,pages_read_user_content"
						onCompleted={console.log}
						onError={console.error}
					>
						<span>{t('changePermission')}</span>
					</LoginButton>
					<Button
						as="a"
						href="https://www.facebook.com/pages/create/?ref_type=site_footer"
						target="_blank"
						positive
						style={{ marginLeft: 'auto', marginRight: '15px' }}
					>
						{t('addPage')}
					</Button>
				</div>
				<Table>
					{_.map(this.state.list, (it) => (
						<Table.Row key={it.id}>
							<Table.Cell key={it.id} width={12}>
								<a href={'https://m.me/' + it.id} target="_blank" rel="noopener noreferrer">
									{it.name}
								</a>
							</Table.Cell>
							<Table.Cell key={it.id} style={{ textAlign: 'end' }}>
								{/* {console.log('s', _.find(this.state.connectedPages, { accessToken: it.access_token }))} */}
								<Button
									color={!_.find(this.state.connectedPages, { shop: it.id }) ? 'green' : 'red'}
									loading={this.state.buttonLoading === it.id}
									onClick={
										!_.find(this.state.connectedPages, { shop: it.id })
											? this.connect({ id: it.id, token: it.access_token })
											: this.disconnect({ id: it.id, token: it.access_token })
									}
								>
									{!_.find(this.state.connectedPages, { shop: it.id }) ? t('connect') : t('disconnect')}
								</Button>
							</Table.Cell>
						</Table.Row>
					))}
				</Table>
			</div>
		);
	}
}

class FacebookMessenger extends Component {
	state = {
		loading: false,
		activeStep: 0,
	};
	componentDidMount() {
		post('/messenger/register/integrationCount/facebook').then((data) => this.setState({ connectedCount: data.data.result }));
	}
	render() {
		const { t } = this.props;
		/* console.log(this.props); */
		if (this.state.loading)
			return (
				<Page
					header={
						<Breadcrumb size="big">
							<Breadcrumb.Section as={Link} to={`/settings`}>
								<Icon name="setting" />
								{t('settings')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon="right chevron" />

							<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
								{t('integrations')}
							</Breadcrumb.Section>
							<Breadcrumb.Divider icon={{ name: 'asterisk', loading: true }} />
						</Breadcrumb>
					}
					flex
				>
					<MyMenu activeItem="facebook">
						<Page.Loader />
					</MyMenu>
				</Page>
			);

		return (
			<Page
				header={
					<Breadcrumb size="big">
						<Breadcrumb.Section as={Link} to={`/settings`}>
							<Icon name="setting" />
							{t('settings')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />

						<Breadcrumb.Section as={Link} to={`/settings/integrations`}>
							{t('integrations')}
						</Breadcrumb.Section>
						<Breadcrumb.Divider icon="right chevron" />
						<Breadcrumb.Section>Facebook Messenger</Breadcrumb.Section>
					</Breadcrumb>
				}
				extra={
					<div className="ml-auto">
						<AccountProgress></AccountProgress>
					</div>
				}
				flex
			>
				<MyMenu activeItem="facebook">
					<Page.Wrap>
						<Tab
							menu={{ secondary: true, pointing: true }}
							panes={[
								{
									menuItem: { key: 'connection', content: 'Facebook Messenger' },
									render: () => this.renderConnectionPane(),
								},
								{
									menuItem: { key: 'comment-options', content: t('facebookCommentOptions') },
									render: () => <FacebookCommentOptions />,
								},
							]}
						/>
					</Page.Wrap>
				</MyMenu>
			</Page>
		);
	}

	renderConnectionPane() {
		const { t } = this.props;
		let { connectedCount } = this.state;
		return (
			<Tab.Pane>
				<FacebookProvider appId="296064065127789">
					<Status>
						{(info) => {
							let activeStep = info.status === 'connected' ? 1 : 0;
							return (
								<div>
									{/* 	{JSON.stringify(info)} */}
									{connectedCount ? (
										<Message info style={{ textAlign: 'center' }}>
											{t('connectedCount', { count: connectedCount })}
										</Message>
									) : (
										''
									)}
									<Message info style={{ textAlign: 'center' }}>
										{t('facebookDesc', { title: window.CONFIG.title })}
									</Message>
									<Step.Group widths={4}>
										<Step active={activeStep === 0} completed={activeStep === 1}>
											<Icon name="facebook" />
											<Step.Content>
												<Step.Title>{t('loginFacebook')}</Step.Title>
											</Step.Content>
										</Step>
										<Step active={activeStep === 1}>
											<Icon name="linkify" />
											<Step.Content>
												<Step.Title>{t('connectToFacebookPage')}</Step.Title>
											</Step.Content>
										</Step>
									</Step.Group>
									{!activeStep && (
										<Segment attached className="login">
											<LoginButton
												className="ui button facebook"
												scope="pages_manage_metadata,pages_messaging,business_management,pages_read_engagement,pages_manage_engagement,pages_read_user_content"
												onCompleted={console.log}
												onError={console.error}
											>
												<span>{t('loginWithFacebook')}</span>
											</LoginButton>
										</Segment>
									)}
									{activeStep ? <PageSeceltor t={t} /> : ''}
								</div>
							);
						}}
					</Status>
				</FacebookProvider>
			</Tab.Pane>
		);
	}
}

const stateToProps = (state) => ({ access: state.access, product: state.product, location: state.router.location });

export default connect(stateToProps)(withTranslation()(FacebookMessenger));
